module.exports = __webpack_public_path__ + "static/media/barberscape-2.97a2fae6.jpg";